import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type SecurityStore } from 'pages/settings/pages/personal/pages/account/pages/security'

type IPhoneModalActionsProps = {
  store: SecurityStore
}

export const PhoneModalActions = observer(({ store }: IPhoneModalActionsProps) => {
  const { loading, phoneInputStore, onClosePhoneModal, handlePhoneModalConfirm } = store
  const isConfirmDisabled = loading || !phoneInputStore.isValidNumber

  return (
    <>
      <Button
        text='Cancel'
        onClick={() => onClosePhoneModal(true)}
        typeBtn={'contained'}
        size={'medium'}
        contained={'secondary'}
      />
      <Button
        text='Confirm'
        onClick={() => void handlePhoneModalConfirm()}
        disabled={isConfirmDisabled}
        loading={loading}
      />
    </>
  )
})
